import InterpreterModeOutlinedIcon from "@mui/icons-material/InterpreterModeOutlined";
import { Theme, useTheme } from "@mui/material/styles";
import { useKeycloak } from "@react-keycloak/web";
import { useAtomValue, useSetAtom } from "jotai";
import React, { useMemo, useState } from "react";
import { INTERVIEW_LIST_TAB_DIMENSIONS } from "../../components/discovery/utils/constants";
import InterviewListTabs from "../../components/discovery/interview/InterviewListTabs";
import MaterialInterviewList from "../../components/discovery/interview/material-interview-list";
import { INTERVIEW_NAVIGATION_TABS } from "../../constants";
import { baseAtom } from "../../stores/jotai/base";
import { interviewFindingsAtom } from "../../stores/jotai/insights/interviewFindings";
import { interviewsAtom } from "../../stores/jotai/interviews/interviews";
import { useGetFindings } from "../../tanstackQuery/queries/findings";
import EmptyInterviewCard from "./EmptyInterviewCard";
import HomeSegmentCard from "./HomeSegmentCard";
import HomeSegmentContent from "./HomeSegmentContent";
import HomeSegmentTitle from "./HomeSegmentTitle";
import InterviewsSegmentCardSkeleton from "./Skeleton/InterviewsSegmentCardSkeleton";
const CONTAINER_STYLES = (theme: Theme) => ({
  ".MuiTableContainer-root": {
    height: `calc(100% - ${INTERVIEW_LIST_TAB_DIMENSIONS.HEIGHT}px) !important`
  },
  ".InterviewListTab .MuiTab-root": {
    color: theme.custom.text
  },
  ".InterviewListNameCell": {
    "&, > div": {
      width: "300px !important"
    }
  }
});

const InterviewsSegmentCard = () => {
  const base = useAtomValue(baseAtom);
  const { keycloak } = useKeycloak();
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState<string>(
    INTERVIEW_NAVIGATION_TABS.DRAFT
  );
  const setInterviewFindingsAtom = useSetAtom(interviewFindingsAtom);
  const allInterview = useAtomValue(interviewsAtom);

  const { findings: findingsData, isFindingLoading } = useGetFindings(
    { accessToken: keycloak.token },
    { groupID: base.team.groupID, userID: base.user.userID, isMetaInsightEnabled :true },
    { enabled: !!(base?.team?.groupID, base.user.userID) }
  );

  React.useEffect(() => {
    if (findingsData && !isFindingLoading) {
      setInterviewFindingsAtom(findingsData?.interviews);
    }
  }, [findingsData]);

  const filteredInterviews = useMemo(() => {
    if (allInterview) {
      return allInterview?.filter(
        (interview) => interview.status === selectedTab
      );
    }
  }, [allInterview, selectedTab]);

  const onTabChange = (event, target: string) => {
    setSelectedTab(target);
  };
  const isBaseLoading = Object.keys(base.user || {})?.length === 0;
  const isAllInterviewLoading = !allInterview;
  const publishedInterviewLength = allInterview?.filter(
    (interview) => interview?.status === "published"
  )?.length;

  return (
    <>
      {isBaseLoading || isFindingLoading || isAllInterviewLoading ? (
        <InterviewsSegmentCardSkeleton />
      ) : (
        <HomeSegmentCard sx={CONTAINER_STYLES(theme)}>
          <HomeSegmentTitle>
            <InterpreterModeOutlinedIcon /> Interviews
          </HomeSegmentTitle>
          <HomeSegmentContent>
            {allInterview?.length > 0 ? (
              <>
                <InterviewListTabs
                  value={selectedTab}
                  onChange={onTabChange}
                  hideExportButton={true}
                  draftInterviewLength={
                    allInterview?.length - publishedInterviewLength
                  }
                  publishedInterviewLength={publishedInterviewLength}
                />
                <MaterialInterviewList
                  interviews={filteredInterviews}
                  isReadOnly={true}
                />
              </>
            ) : (
              <EmptyInterviewCard />
            )}
          </HomeSegmentContent>
        </HomeSegmentCard>
      )}
    </>
  );
};

export default InterviewsSegmentCard;
